import React, { Component } from 'react'
import Video from '../images/reggie-training.mp4'

export default class Cta extends Component {
  render() {
    return (
        <>
            <video src={ Video } autoPlay loop playsInline muted></video>
            <section className="cta-header">
                <h1>Speed, Agility Done Right</h1>
            </section>
        </>
    )
  }
}
